import { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// Imports => Utilities
import { AcIsSet, AcIsArray } from '@opp/ui-kit';

// Imports => Atoms
import AcTransactionListItem from '@atoms/ac-transaction-list-item/ac-transaction-list-item';

const _CLASSES = {
  MAIN: 'ac-transaction-list',
  CONTAINER: 'ac-transaction-list__container',
};

const AcTransactionList = ({ items = [], className }) => {
  const getContainerClassNames = useMemo(() => {
    return clsx(_CLASSES.CONTAINER);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, className);
  }, [className]);

  const renderItems = useMemo(() => {
    if (!AcIsSet(items) || !AcIsArray(items)) return null;

    const collection = items;
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const item = collection[n];

      const object = (
        <AcTransactionListItem
          key={`ac-transaction-list-item-${item.uid}`}
          data={item}
        />
      );

      result.push(object);
    }

    return result;
  }, [items]);

  return (
    <div className={getMainClassNames}>
      <div className={getContainerClassNames}>{renderItems}</div>
    </div>
  );
};

AcTransactionList.propTypes = {
  /**
     * For CSS customization
     */
  className: PropTypes.string,
};

export default memo(AcTransactionList);
